export default __webpack_public_path__ + "static/media/keepsafe.3570359f.png";